import DomainParent from '@/domain/parent/DomainParent.js'

/* eslint-disable */
export default class labResult extends DomainParent {
  constructor( data ) {
    super(data)
    if ( data != null ) {
        this.Batch = data.Batch
	    this.Brand = data.Brand
		this.Product = data.Product
		this.Category = data.Category
		this.Character = data.Character
		this.Expity = data.Expity
		this.THC = data.THC
		this.CBD = data.CBD
		this.QAFile = data.QAFile
    }
    else {
        this.Batch = ''
	    this.Brand = ''
		this.Product = ''
		this.Category = ''
		this.Character = ''
		this.Expity = ''
		this.THC = ''
		this.CBD = ''
		this.QAFile = ''
    }
  }

  get toDto() {
    let dto = {}
        dto.Batch = this.Batch
        dto.Brand = this.Brand
        dto.Product = this.Product
        dto.Category = this.Category
        dto.Character = this.Character
        dto.Expity = this.Expity
        dto.THC = this.THC
        dto.CBD = this.CBD
        dto.QAFile = this.QAFile
    return dto
  }
}



// WEBPACK FOOTER //
// ./src/domain/labResult.js